module.exports = __webpack_public_path__ + "img/go_proxy_not_available.f509aed8.png";